module.exports = __webpack_public_path__ + "img/carbon1.259fabb3.png";